import React from "react";
import { Link } from "react-router-dom";
import styles from "./SideNav.module.css";

export type SideNavItem = {
  // Stable React key (title or id).
  key: string;
  title: string;
  to: string;
  icon: React.ReactNode;
  active: boolean;
  external?: boolean; // when true, renders <a> with target="_blank" instead of <Link>
};

// Shared left-hand nav list rendered by both the TrustCall and Compliance Guide
// layouts (DRY). Each layout supplies its own items + responsive wrapper; this
// component owns the consistent flat-list look.
const SideNav: React.FC<{ items: SideNavItem[] }> = ({ items }) => (
  <ul className={styles.nav}>
    {items.map((item) => (
      <li key={item.key}>
        {item.external ? (
          <a
            href={item.to}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.navLink} ${item.active ? styles.active : ""}`}
          >
            <span className={styles.icon}>{item.icon}</span>
            <span className={styles.label}>{item.title}</span>
          </a>
        ) : (
          <Link
            to={item.to}
            className={`${styles.navLink} ${item.active ? styles.active : ""}`}
          >
            <span className={styles.icon}>{item.icon}</span>
            <span className={styles.label}>{item.title}</span>
          </Link>
        )}
      </li>
    ))}
  </ul>
);

export default SideNav;
